import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '~components/header';
import Navigation from '~components/navigation';
import LawsItemPageLazy from '~routes/main/laws-item-page/lazy';
import DocsItemPageLazy from '~routes/main/docs-item-page/lazy';
import LawsPageLazy from '~routes/main/laws-page/lazy';
import FAQPageLazy from '~routes/main/faq-page/lazy';
import DigestsPageLazy from '~routes/main/digests-page/lazy';
import DigestsItemPageLazy from '~routes/main/digests-item-page/lazy';
import UserProfile from '~routes/main/userprofile';
import NewsPageLazy from './news-page/lazy';
import NewsItemPageLazy from './news-item-page/lazy';
import StatisticsPageLazy from './statistics-page/lazy';
import StatisticsItemPageLazy from './statistics-item-page/lazy';
import NewProjectPageLazy from './new-project-page/lazy';
import RiskCardPageLazy from './risk-card-page/lazy';
import CalendarPageLazy from '~routes/main/calendar-page/lazy';

import { checkUserExpirationDateExpired } from '~utils/helpers';

function Main({ isMobile, isNewsUserLogged, isLawsUserLogged, isNewsAvailable, isLawsAvailable, ecosystemFunctions }) {
    const isNoScroll = window.location.href.search('/map') !== -1;
    return (
        <React.Fragment>
            <Element name="page-top" />
            <Header>
                <Navigation isMobile={isMobile} />
            </Header>
            <div className={`main${isNoScroll ? ' no-scroll' : ''}`}>
                <Switch>
                    {isNewsUserLogged && isNewsAvailable && <Route path="/news/:id" component={NewsItemPageLazy} />}
                    {isNewsUserLogged && isNewsAvailable && <Route path="/news" exact component={NewsPageLazy} />}
                    
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/laws/:id/:token" component={LawsItemPageLazy} />
                    )}
                    {isLawsUserLogged && isLawsAvailable && <Route path="/laws/:id" component={LawsItemPageLazy} />}

                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/docs/:id/:token" component={DocsItemPageLazy} />
                    )}
                    {isLawsUserLogged && isLawsAvailable && <Route path="/docs/:id" component={DocsItemPageLazy} />}

                    {isLawsUserLogged && isLawsAvailable && <Route path="/laws" exact component={LawsPageLazy} />}
                    <Route path="/faq" component={FAQPageLazy} />
                    <Route path="/user" component={UserProfile} />
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_digests ? (
                        <Route path="/digests/:id/:token" component={DigestsItemPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_digests ? (
                        <Route path="/digests/:id" component={DigestsItemPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_digests ? (
                        <Route path="/digests" component={DigestsPageLazy} />
                    ) : null}
                    {/* CALENDAR */}
                    {isLawsUserLogged && isLawsAvailable && <Route path="/calendar" component={CalendarPageLazy} />}
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/statistics/:id" component={StatisticsItemPageLazy} />
                    )}
                    {isLawsUserLogged && isLawsAvailable && (
                        <Route path="/statistics" exact component={StatisticsPageLazy} />
                    )}
                    {(isLawsUserLogged &&
                        isLawsAvailable &&
                        ecosystemFunctions instanceof Object &&
                        ecosystemFunctions.add_new_law_project) ||
                    ecosystemFunctions.edit_new_law_project ? (
                        <Route path="/new-project" component={NewProjectPageLazy} />
                    ) : null}
                    {isLawsUserLogged &&
                    isLawsAvailable &&
                    ecosystemFunctions instanceof Object &&
                    ecosystemFunctions.create_risk_map ? (
                        <Route path="/risk-card" component={RiskCardPageLazy} />
                    ) : null}
                    {/* {((isLawsUserLogged && isLawsAvailable) || (isNewsUserLogged && isNewsAvailable)) && (
                        <Redirect to="/calendar" />
                    )} */}
                    {isNewsUserLogged && isNewsAvailable && <Redirect to="/news" />}
                    {isLawsUserLogged && isLawsAvailable && <Redirect to="/laws" />}
                    {!isNewsAvailable && !isLawsAvailable && <Redirect to="/user/settings" />}
                </Switch>
            </div>
        </React.Fragment>
    );
}

Main.propTypes = {
    isMobile: PropTypes.bool,
    isNewsUserLogged: PropTypes.bool,
    isLawsUserLogged: PropTypes.bool,
    isNewsAvailable: PropTypes.bool,
    isLawsAvailable: PropTypes.bool,
    ecosystemFunctions: PropTypes.object,
};

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
    isNewsUserLogged: !checkUserExpirationDateExpired(state.user.newsUser.token_expires_at),
    isLawsUserLogged: !checkUserExpirationDateExpired(state.user.lawsUser.token_expires_at),
    isNewsAvailable: state.user.feed_settings && state.user.feed_settings.news,
    isLawsAvailable: state.user.feed_settings && state.user.feed_settings.laws,
    ecosystemFunctions: state.user.ecosystem.functions,
});

export default connect(mapStateToProps)(Main);
export { Main };



// WEBPACK FOOTER //
// ./src/routes/main/index.js